/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import Modal from 'react-modal';
import { masks, cardiver } from "../assets";
import Utility from "../utility/utility"

const CardoverlayCommon = (props) => {

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedConsequence, setSelectedConsequence] = useState(0);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(0%, -50%)',

    }
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    //  subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <div>
      <Modal
        isOpen={true}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={customStyles}
        transparent={true}
      >
        <div  >
          <div >
            <div >
              <div className="modal-header hide">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span className="close-btn" aria-hidden="true">
                    &times;
                  </span>
                </button>
              </div>
              <div >

                <div className="backcardlay">
                  <div className="container overlay-1">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <div className="card overlay-card-1 ">
                        {props.tag && (
                          <span className="position-absolute badge mt-2 py-1 px-2 bg-light fw-bold"
                            style={{ fontSize: '20px', zIndex: 999, left: '10px', textAlign: "left", marginBottom: '20px', color: '#f44336' }} >
                              {props.tag} 
                              <br />
                              It keeps returning until you decide.
                          </span>
                        )}
                        <header className={props.questionObject?.Decision === 2 ? "overlay1-1-header" : "overlay-1-header"}
                         style={props.tag && {paddingTop: "60px"}}>
                          <h5 className="line-height memphis-mediums">
                            {props.questionObject?.Column3}
                          </h5>
                          {props.questionObject?.Decision === 2 && <h1 className="text-right tect-white overy-everyone Pacifico-Regulars">
                            everyone!
                          </h1>}
                        </header>
                        <div className="col-md-12">
                          {props?.questionObject?.Column4 !== "" && <>
                            <h5 className="w-set-check mt-2 memphis-medium">You:</h5>
                            <label className={`container w-checkox memphis-medium color-mistake-pay ${props?.v1 ? "disable" : ""}`} >
                              <span>{props?.questionObject?.Column4.replace("COIN TOSS", "")}</span>{props?.questionObject?.Column4?.includes("COIN TOSS") && <span className="brown-texts"><b>COIN TOSS :</b></span>}
                              <span className="m-auto Pacifico-Regulars">
                                {" "} {!props?.questionObject?.Column4?.includes("COIN TOSS") && (props?.questionObject?.Column7?.includes("Add") || props?.questionObject?.Column7?.includes("Lose")) && <img src={cardiver} className="width-ovwelay-image" />}{" "}
                                {Utility.printTextwithColor(props?.questionObject?.Column7)}
                              </span>
                              <input name="cardoverlay1_option[]" disabled={props?.v1} onChange={async (e) => {

                                if (props?.questionObject?.Column4?.includes("COIN TOSS")) {
                                  const no = Utility.randomIntFromInterval(1, 2)
                                  const obj = await Utility.checkAssetType(no === 1 ? props.questionObject?.Column12 : props.questionObject?.Column13, props.assets)
                                  setSelectedConsequence(no)

                                  setTimeout(() => {
                                    if (obj.assetAvailabity) {
                                      props.checkCardOverlayCallback(e.target, 1, obj.obj)
                                    } else {
                                      props.keepOpenCallback(props.assets)
                                    }
                                  }, 1000)
                                } else {
                                  const obj = await Utility.checkAssetType(props.questionObject?.Column7, props.assets)
                                  if (obj.assetAvailabity) {
                                    props.checkCardOverlayCallback(e.target, 1, obj.obj)
                                  } else {
                                    props.keepOpenCallback(props.assets)
                                  }
                                }

                              }} type="radio" />
                              
                              <span className="checkmark">
                                <span class="tooltiptext">You don't have this asset!</span>
                              </span>
                            </label>

                            {props?.questionObject?.Column4?.includes("COIN TOSS") && <>

                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 1 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"  "}
                                <span className="brown-texts m-auto Pacifico-Regulars">
                                  {"Heads: "}
                                </span>
                                {props?.questionObject?.Column10}
                                <span className="m-auto Pacifico-Regulars">
                                  {"  "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column12)}
                                </span>

                              </label>
                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 2 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"    "}
                                <span className="brown-texts m-auto Pacifico-Regulars">
                                  {"Tails: "}
                                </span>

                                {props?.questionObject?.Column11}
                                <span className="m-auto Pacifico-Regulars">
                                  {" "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column13)}
                                </span>
                              </label>
                            </>}
                          </>}
                          {props?.questionObject?.Column5 !== "" && <>
                            <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
                              <label className={`container w-checkox memphis-medium color-mistake-pay ${props?.v2 ? "disable" : ""}`} >
                              <span>{props?.questionObject?.Column5.replace("COIN TOSS", "")}</span>{props?.questionObject?.Column5?.includes("COIN TOSS") && <span className="brown-texts"><b>COIN TOSS :</b></span>}

                              <span className="m-auto Pacifico-Regulars">
                                {" "} {!props?.questionObject?.Column5.includes("COIN TOSS") && (props?.questionObject?.Column8.includes("Add") || props?.questionObject?.Column8.includes("Lose")) && <img src={cardiver} className="width-ovwelay-image" />}{" "}
                                {Utility.printTextwithColor(props?.questionObject?.Column8)}
                              </span>
                              <input name="cardoverlay1_option[]" disabled={props?.v2} onChange={async (e) => {

                                if (props?.questionObject?.Column5.includes("COIN TOSS")) {
                                  const no = Utility.randomIntFromInterval(1, 2)
                                  const obj = await Utility.checkAssetType(no === 1 ? props.questionObject?.Column12 : props.questionObject?.Column13, props.assets)
                                  setSelectedConsequence(no)

                                  setTimeout(() => {
                                    if (obj?.assetAvailabity) {
                                      props?.checkCardOverlayCallback(e.target, 1, obj.obj)
                                    } else {
                                      props?.keepOpenCallback(props.assets)
                                    }
                                  }, 1000)
                                } else {
                                  const obj = await Utility.checkAssetType(props.questionObject?.Column8, props.assets)

                                  if (obj?.assetAvailabity) {
                                    props?.checkCardOverlayCallback(e.target, 1, obj.obj)
                                  } else {
                                    props?.keepOpenCallback(props.assets)
                                  }
                                }
                              }} type="radio" />
                              <span className="checkmark">
                                <span class="tooltiptext">You don't have this asset!</span>
                              </span>
                            </label>

                            {props?.questionObject?.Column5?.includes("COIN TOSS") && <>

                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 1 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"  "}
                                <span className="brown-texts m-auto Pacifico-Regulars">
                                  {"Heads: "}
                                </span>
                                {props?.questionObject?.Column10}
                                <span className="m-auto Pacifico-Regulars">
                                  {"  "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column12)}
                                </span>

                              </label>
                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 2 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"    "}
                                <span className="brown-texts m-auto Pacifico-Regulars">

                                  {"Tails: "}
                                </span>

                                {props?.questionObject?.Column11}
                                <span className="m-auto Pacifico-Regulars">
                                  {" "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column13)}
                                </span>

                              </label>
                            </>}
                          </>}
                          {props?.questionObject?.Column6 !== "" && <>
                            <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
                            <label className={`container w-checkox memphis-medium color-mistake-pay ${props?.v3 ? "disable" : ""}`} >
                              {props?.questionObject?.Column6}
                              <span className="m-auto Pacifico-Regulars">
                                {" "}
                                <img src={masks} className="width-ovwelay-image" />{" "}
                                {Utility.printTextwithColor(props?.questionObject?.Column9)}
                              </span>
                              <input name="cardoverlay1_option[]" disabled={props?.v3} onChange={async (e) => {
                                const obj = await Utility.checkAssetType(props.questionObject?.Column9, props.assets)
                                if (obj.assetAvailabity) {
                                  props.checkCardOverlayCallback(e.target, 1, obj.obj)
                                } else {
                                  props.keepOpenCallback(props.assets)
                                }
                              }
                              } type="radio" />
                              <span className="checkmark">
                                <span class="tooltiptext">You don't have this asset!</span>
                              </span>
                            </label>
                            {props?.questionObject?.Column6?.includes("COIN TOSS") && <>

                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 1 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"  "}
                                <span className="brown-texts m-auto Pacifico-Regulars">
                                  {"Heads: "}
                                </span>
                                {props?.questionObject?.Column10}
                                <span className="m-auto Pacifico-Regulars">
                                  {"  "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column12)}
                                </span>

                              </label>
                              <label style={{ marginLeft: '10px' }} className={selectedConsequence === 2 ? "selected_answer_text container w-checkox memphis-medium color-mistake-pay" : "container w-checkox memphis-medium color-mistake-pay"}>
                                {"    "}
                                <span className="brown-texts m-auto Pacifico-Regulars">

                                  {"Tails: "}
                                </span>

                                {props?.questionObject?.Column11}
                                <span className="m-auto Pacifico-Regulars">
                                  {" "} {<img src={cardiver} className="width-ovwelay-image" />}{" "}
                                  {Utility.printTextwithColor(props?.questionObject?.Column13)}
                                </span>

                              </label>
                            </>}
                          </>}
                        </div>
                        <div className="col-md-12 text-right mt-4">
                          <h6 className="health-overlay-color font-economy memphis-medium">&copy;<span className="ml-1">Health Economy 2019</span></h6>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div className="card-overlay-2 bg-overlay">
                          <div className="text-center">
                            <button id="overlay-keepopen-button" onClick={(e) => props.keepOpenCallback(props.assets)} type="text" className="overlay-button">
                              Keep Open
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CardoverlayCommon;
